import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants";

interface PaymentsProps {
  topUpNumber: string;
  topUpDate: string;
  receiptDetail: string;
  phone: string;
}

function Payments({ topUpNumber, topUpDate, receiptDetail, phone }: PaymentsProps) {
  const navigate = useNavigate();

  return (
    <>
      <div className="text-center">
        <img src="/assets/success-top-up.png" alt="Pago exitoso" />
        <h2 className="step-title mt-2">Pago exitoso</h2>
        <h3 className="step-title">{phone}</h3>
      </div>

      <div className="success-user-info text-center mt-5">
        <p>
          Recarga <span>{topUpNumber}</span>
        </p>
        <hr />
        <p className="mt-4">
          <span>{receiptDetail}</span>
          <br />
          {topUpDate}
        </p>
      </div>

      <button
        type="button"
        className="btn-recharge-again"
        onClick={() => navigate(ROUTES.LANDING)}
      >
        Hacer otra recarga
      </button>
    </>
  );
}

export default Payments;
